import { createSelector } from '@ngrx/store';
import { State } from './submissions-page.reducer';
import { selectSubmissionsPageState } from '../index';

export const selectSubmissionsPageTableState = createSelector(selectSubmissionsPageState, (state: State) =>
  state?.tableState?.filters ? state.tableState : undefined
);

export const selectSubmissionsPageUserSettings = createSelector(selectSubmissionsPageState, (state: State) => state.userSettings ?? undefined);
